import { render, staticRenderFns } from "./leftRow.vue?vue&type=template&id=04ed522a&scoped=true"
import script from "./leftRow.vue?vue&type=script&lang=js"
export * from "./leftRow.vue?vue&type=script&lang=js"
import style0 from "./leftRow.vue?vue&type=style&index=0&id=04ed522a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed522a",
  null
  
)

export default component.exports